import { useState } from "react";
import AssetService from "../services/api/assets";
import { useSnackbar } from "notistack";


export const useBusinessDriver = () => {

    const [driverList, setDriverList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [viewDriver, setViewDriver] = useState({});

    const { enqueueSnackbar } = useSnackbar(); 

    const businessDriverList = (org_id) =>{
        setLoading(true)
        AssetService.businessDriverList(org_id).then((res)=>{
            console.log('businessDriverList xxxxxxxxxxxxx', res)
            setDriverList(res.data.data.flatMap(item => item.profile_info))
            setLoading(false)
        }).catch((err)=>{
            console.log('businessDriverList errrr', err)
            setLoading(false)
            const errorMessage = err?.response?.data?.error || err.message;

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const businessViewDriver = (parameters) => {
        setLoading(true)
        AssetService.businessViewDriver(parameters).then((res)=>{
            console.log('businessViewDriver xxxxxxxxxxxxx', res)
            setViewDriver(res.data.data)
            setLoading(false)
        }).catch((err)=>{
            console.log('businessViewDriver errrr', err)
            setLoading(false)
            const errorMessage = err?.response?.data?.error || err.message;

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateDriverStatus = (parameters, setOpen) => {
        setLoading(true)
        AssetService.updateDriverStatus(parameters).then((res)=>{
            console.log('updateDriverStatus xxxxxxxxxxxxx', res)
            setOpen(false)
            businessDriverList(parameters.org_id) // Refresh the driver list after update
            setLoading(false)
        }).catch((err)=>{
            console.log('updateDriverStatus errrr', err)
            setLoading(false)
            const errorMessage = err?.response?.data?.error || err.message;

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }
    
    return{
        businessDriverList, loading, driverList,

        businessViewDriver, viewDriver,

        updateDriverStatus
    }
}